import { Layout } from '../../components/guest'
import { SettingComponent } from '../../components/guest/SettingComponent'
import { useSetting } from '../../hooks/useSetting'

export function SettingFrame() {
  const {
    audioInputOptions,
    videoInputOptions,
    audioInputOption,
    videoInputOption,
    fetchDevices,
    save,
    onChangeAudio,
    onChangeVideo,
  } = useSetting()

  return (
    <Layout>
      <SettingComponent
        audioInputOptions={audioInputOptions}
        videoInputOptions={videoInputOptions}
        audioInputOption={audioInputOption}
        videoInputOption={videoInputOption}
        fetchDevices={fetchDevices}
        save={save}
        onChangeAudio={onChangeAudio}
        onChangeVideo={onChangeVideo}
      />
    </Layout>
  )
}
